// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__33VJp","panel":"Robot_panel__0KEtx","wrapper":"Robot_wrapper__XGKlu","info":"Robot_info__48gFF","unit":"Robot_unit__wH0vx"};